










import { Component, Prop, Vue } from 'vue-property-decorator'
import { ViewType } from '@/interfaces/ViewType'

@Component
export default class PreviewType extends Vue {
  @Prop()
  value: ViewType | null

  @Prop({ type: Boolean, default: false })
  selected: boolean
}
